import { IContainer } from "../types/container";
import { isDisabled } from "./time";

export const filterUniqueContainersById = (containers: IContainer[]): IContainer[] => {
  const seen = new Set<number>();
  return containers.filter((container) => {
    if (seen.has(container.containerId)) return false;
    seen.add(container.containerId);
    return true;
  });
};

export const sortContainersByDisableTime = (containers: IContainer[], year: number): IContainer[] => {
  return containers.sort((a, b) => {
    const isDisabledA = isDisabled(a.disableTime, year);
    const isDisabledB = isDisabled(b.disableTime, year);

    if (isDisabledA && !isDisabledB) return 1;
    else if (!isDisabledA && isDisabledB) return -1;
    return 0;
  });
};
